import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { FaTrash, FaPlus, FaTools } from "react-icons/fa";

function Pages() {
  const [pages, setPages] = useState([]);

  const fetchPages = () => {
    axios.get("/api/pages").then((res) => {
      setPages(res.data || []);
    });
  };

  const handleDeletePage = (id) => {
    if (window.confirm("Are you sure you want to delete this page?")) {
      axios.delete("/api/pages/" + id).then((res) => {
        if (res.status === 200) {
          fetchPages();
        }
      });
    }
  };

  useEffect(() => {
    fetchPages();
  }, []);

  return (
    <div className="container-fluid mt-2">
      <div className="table-responsive">
        <div className="table-wrapper">
          <div className="table-title">
            <div className="row">
              <div className="col-sm-4">
                <h2>
                  <b>Pages</b>
                </h2>
              </div>
              <div className="col-sm-8">
                <Link className="btn btn-info add-new float-right" title="New Blog" to={`/pages/new`}>
                  <FaPlus /> New Page
                </Link>
              </div>
            </div>
          </div>
          <table className="table table-striped table-hover table-bordered bg-white">
            <thead>
              <tr>
                <th className="text-center" style={{ width: "50px" }}>
                  ID
                </th>
                <th>Name</th>
                <th className="text-center" style={{ width: "120px" }}>
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {pages.map((page) => (
                <tr key={"s_" + page.id}>
                  <td className="text-center">{page.id}</td>
                  <td className="">{page.name}</td>
                  <td className="text-center actions">
                    <span
                      className="action-btn text-danger px-1"
                      title="Delete"
                      onClick={() => handleDeletePage(page.id)}
                    >
                      <FaTrash />
                    </span>
                    <Link
                      className="action-btn text-success px-1"
                      title="Edit Page Content"
                      to={`/pages/edit/${page.id}`}
                    >
                      <FaTools />
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Pages;
